<script setup>
/**
 * The flag-gated host for the ticket surface.
 *
 * Both the list route and the workroom route render this shell, so the two
 * screens land in it without touching routing again: with no `displayId` it is
 * the queue, with one it is the workroom. Nothing renders while the
 * `support_cases` flag is off — the server refuses the endpoints anyway, and a
 * blank screen is the honest answer for an account that has no ticket engine.
 */
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import CaseDetailView from './CaseDetailView.vue';
import CaseListView from './CaseListView.vue';

const props = defineProps({
  displayId: {
    type: [String, Number],
    default: '',
  },
});

const { accountId } = useAccount();
const isFeatureEnabledonAccount = useMapGetter(
  'accounts/isFeatureEnabledonAccount'
);

const isFeatureEnabled = computed(() =>
  isFeatureEnabledonAccount.value(accountId.value, FEATURE_FLAGS.SUPPORT_CASES)
);

const isWorkroom = computed(() => Boolean(props.displayId));
</script>

<template>
  <section
    v-if="isFeatureEnabled"
    class="flex flex-col w-full h-full min-h-0 gap-4 px-6 py-5 overflow-hidden bg-n-background"
    data-testid="support-cases-shell"
  >
    <CaseDetailView
      v-if="isWorkroom"
      :key="displayId"
      :display-id="displayId"
    />
    <CaseListView v-else />
  </section>
</template>
